// Polyfills

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import BackendLogger from '@/plugins/backend-logger';
import snackbarPlugin from '@/plugins/snackbar';
import '@/plugins/keycloak';
import {i18n} from './plugins/i18next';

import VueGeolocation from 'vue-browser-geolocation';

//List with icons:
// https://jossef.github.io/material-design-icons-iconfont/
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import axios from 'axios';
import ModuleSwitcher from '@/plugins/module-switcher.js';
import Editor from '@tinymce/tinymce-vue';

// import different libraries
import VueMask from 'v-mask'
import UsersService from "@/modules/core/services/users-service";

/* eslint-disable */
//it doesn't work with another id, only with editor
//attempted by using an alias, but can later not find the tag
Vue.component('editor', Editor);
/* eslint-enable */

Vue.use(snackbarPlugin, {store})
Vue.use(VueGeolocation);
Vue.use(VueMask);
Vue.config.productionTip = false

ModuleSwitcher.installModules();

Vue.$keycloak.init({onLoad: 'check-sso'}).then((auth) => {
  if (auth) {
    store.commit("auth/loginSuccess", Vue.$keycloak);
    Vue.$keycloak.loadUserProfile().then((res) => {
      // if user has set a preferred language
      if(res.attributes.locale) {
        store.commit("translation/storeLanguage", res.attributes.locale[0]);
      } else if(Vue.$store === 'view-elevator-language') {
        store.commit("translation/storeLanguage", "en");
      }

      // update users last login time
      UsersService.updateLoginTime(
        (response) => {
          store.commit('auth/setPatchPopup', response.data);
        }
      );

      new Vue({
        router,
        store,
        vuetify,
        i18n,
        render: h => h(App)
      }).$mount('#app')
    })

    // set auth header for all axios requests
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + Vue.$keycloak.token;

    setInterval(() => {
      Vue.$keycloak.updateToken(70).then((refreshed) => {
        if (refreshed) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + Vue.$keycloak.token;
        } else {
          //BackendLogger.warn('Token not refreshed, valid for '
          //     + Math.round(Vue.$keycloak.tokenParsed.exp + Vue.$keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds')
        }
      }).catch(() => {
        //BackendLogger.error('Failed to refresh token');
      });

    }, 60000)
  } else {
    new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: h => h(App)
    }).$mount('#app')
  }

}).catch(() => {
  BackendLogger.error("Authenticated Failed");
});


Vue.prototype.$logger = BackendLogger;

// cancel token request interceptor
axios.interceptors.request.use((config) => {
  // create new abort controller and pass it to te request
  const controller = new AbortController();
  config.signal = controller.signal;

  // also pass it to vuex to make cancellation available from anywhere
  store.commit('request/ADD_CANCEL_ABORT_CONTROLLER', controller);

  return config;
}, (error) => {
  return Promise.reject(error);
});
